var React = require('react');

function IconCheck (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,"\n      .e6d6beab-9455-4e6c-aa7a-7c7ada802c8f {\n        fill: #262626;\n      }\n    ")),React.createElement("g",{"id":"f4cefb1e-6157-4fe9-9398-baf0d68f2a28","data-name":"check-inner","key":1},React.createElement("g",{"id":"b61bd5fe-da25-4620-9807-e7d42902debe","data-name":"Path 2338"},React.createElement("path",{"className":"e6d6beab-9455-4e6c-aa7a-7c7ada802c8f","d":"M5.3845,17.0106A1.50006,1.50006,0,0,1,4.115,16.30845L.2302,10.12486a1.5,1.5,0,1,1,2.54-1.59619l2.38281,3.79248L10.197.89488a1.49972,1.49972,0,1,1,2.74414,1.21094L6.75705,16.11607a1.49885,1.49885,0,0,1-1.26318.89063C5.45725,17.00963,5.42112,17.0106,5.3845,17.0106Z"})))]);
}

IconCheck.defaultProps = {"id":"bac785ce-3e99-4ba7-b6ea-85ffe8024659","data-name":"check","viewBox":"0 0 13.06942 17.0106"};

module.exports = IconCheck;

IconCheck.default = IconCheck;
